<template>
    <div class="list-header" :style='"background-image:" + banner + ";"'>
        <div class="list-name"><slot name="list-name"></slot></div>
        <div class="dividing-line"></div>
        <div class="list-memo"><slot name="list-memo"></slot></div>
    </div>
</template>

<script>
export default {
    name: 'listHeader',
    data (){
        return{
            banner: "url('./images/list/list_to_q1.png')",
        }
    },
    methods : {
        getQuery: function (name) {
            let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            let r = window.location.search.substr(1).match(reg);
            if (r != null) {
                return decodeURIComponent(r[2]);
            };
            return null;
        },
    },
    created() {
        this.banner= "url('./images/list/"+this.getQuery("dimension")+".png')";
    }
}
</script>

<style lang="scss" scoped>
.list-header {
    height: 2.7rem;
    padding: .7rem 3.8rem .4rem .22rem;
    font-family: 'Noto Sans SC', sans-serif;
    color:#fff;
    text-align: left;
    // background-image: url('../assets/list-to-date.png');
    background-position: center center;
    background-size: 100% auto;
    background-repeat: no-repeat;
}

.list-name {
    font-size: .5rem;
    font-weight: 700;
    white-space: nowrap;
}

.dividing-line {
    width: .72rem;
    height: .04rem;
    margin: .7rem 0rem .06rem;
    background: linear-gradient(90deg, rgba(255,255,255,1), rgba(255,255,255,0));
}

.list-memo {
    font-size: .22rem;
    font-weight: 400;
}
</style>

